<template>
  <div
    class="fixed top-0 inset-x-0 z-[60] bg-amber-400 text-amber-950 shadow-md border-b-2 border-amber-600"
    role="alert"
    data-testid="masquerade-banner"
  >
    <div class="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-between gap-3">
      <div class="flex items-center gap-3 text-sm font-semibold">
        <span
          >You are masquerading as <code class="font-mono">@{{ targetUsername }}</code
          >.</span
        >
        <span class="text-amber-900">Ends in {{ countdown }}</span>
      </div>
      <button
        type="button"
        class="bg-amber-900 text-amber-50 hover:bg-amber-950 font-semibold text-sm px-3 py-1 rounded"
        @click="handleStop"
      >
        Stop masquerading
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import { useAuthStore } from '../stores/auth'

const authStore = useAuthStore()

const targetUsername = computed(() => authStore.user?.username || '(unknown)')
const expiresAt = computed(() => {
  const raw = authStore.masqueradingAs?.expires_at
  return raw ? new Date(raw).getTime() : null
})

const now = ref(Date.now())
let intervalId = null

onMounted(() => {
  intervalId = setInterval(() => {
    now.value = Date.now()
    if (expiresAt.value && now.value >= expiresAt.value) {
      handleStop()
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (intervalId) clearInterval(intervalId)
})

const countdown = computed(() => {
  if (!expiresAt.value) return '--:--'
  const remaining = Math.max(0, expiresAt.value - now.value)
  const totalSeconds = Math.floor(remaining / 1000)
  const m = String(Math.floor(totalSeconds / 60)).padStart(2, '0')
  const s = String(totalSeconds % 60).padStart(2, '0')
  return `${m}:${s}`
})

async function handleStop() {
  if (intervalId) {
    clearInterval(intervalId)
    intervalId = null
  }
  await authStore.stopMasquerade()
  location.assign('/admin/users')
}
</script>
